import {DoubleArrow} from '@mui/icons-material'
import {Button} from '@mui/material'
import {installerAssignFilter} from 'pages/install/dataConfig/declearFilters'
import InstallAutocomplete from 'pages/install/layout/InstallAutocomplete'
import {useEffect, useState} from 'react'
import {useSelector} from 'react-redux'
import {getInstallList, notInstallable} from 'utils/apiCalling/api'

const SelectInstallableCustomer = (props: any) => {
  const {set, setRenderStep, step, installSubmit, countCall, clear} = props
  const userInfo = useSelector((state: any) => state?.userInfo?.userInfo)
  const [installableList, setInstallableList] = useState<any>(null)
  const getInstallListCall = () => {
    getInstallList(userInfo, 'installCustomer', installerAssignFilter, {
      success: (res: any) => {
        setInstallableList(res)
      },
      fail: (err: any) => {
        console.log(err)
      },
      loading: (loading: boolean) => {},
    })
  }
  const notInstallableCall = () => {
    notInstallable(installSubmit, {
      success: (res: any) => {
        countCall()
        getInstallListCall()
        clear()
      },
      fail: (err: any) => {
        console.log(err)
      },
      loading: (loading: boolean) => {},
    })
  }

  const remindBeforeSelect = (submitData: any) => {
    setRenderStep(1)
  }

  useEffect(() => {
    if (step === 0) {
      getInstallListCall()
    }
  }, [step])

  return (
    <div className={'row mx-0 justify-content-center pb-3'}>
      <InstallAutocomplete
        id='choose-customer'
        label='고객 선택'
        placeholder='고객을 검색하거나 선택해주세요.'
        options={installableList ?? []}
        getOptionLabel={(option: any) =>
          `${option?.customerName} - [${option?.customerNumber}] : ${
            option?.addressNumber ? option?.addressNumber : option?.addressRoad
          }`
        }
        isOptionEqualToValue={(option: any, value: any) =>
          option.customerNumber === value.customerNumber &&
          option.addressNumber === value.addressNumber
        }
        onChange={(rowValue) => {
          set((prev: any) => ({
            ...prev,
            officeId: rowValue?.officeId,
            customerNumber: rowValue?.customerNumber,
            addressNumber: rowValue?.addressNumber,
            addressRoad: rowValue?.addressRoad,
            customerName: rowValue?.customerName,
            installId: userInfo?.userId,
          }))
        }}
      />
      {installSubmit?.customerNumber && (
        <>
          <div
            id={'install-info'}
            className={'row gap-3 my-3 fs-5 border border-gray-600 rounded-2 p-4 mx-0'}
            style={{maxWidth: '100%', wordBreak: 'break-word'}}
          >
            <div className={'d-flex flex-column'}>
              <span className={'fw-bolder mb-1'} style={{fontSize: '1.3rem'}}>
                이름
              </span>
              <span style={{fontSize: '1.5rem', color: '#333'}}>{installSubmit.customerName}</span>
            </div>
            <div className={'d-flex flex-column mt-3'}>
              <span className={'fw-bolder mb-1'} style={{fontSize: '1.3rem'}}>
                고객 번호
              </span>
              <span style={{fontSize: '1.5rem', color: '#333'}}>
                {installSubmit.customerNumber}
              </span>
            </div>
            <div className={'d-flex flex-column mt-3'}>
              <span className={'fw-bolder mb-1'} style={{fontSize: '1.3rem'}}>
                주소
              </span>
              <span style={{fontSize: '1.5rem', color: '#333'}}>
                {installSubmit.addressNumber !== ''
                  ? installSubmit.addressNumber
                  : installSubmit.addressRoad}
              </span>
            </div>
          </div>
          <div className={'w-100 px-0 text-end'}>
            <Button variant={'contained'} color={'error'} onClick={() => notInstallableCall()}>
              설치 불가
            </Button>
            <p className={'mt-1 fw-bolder text-danger'}>설치 불가 수용가일 경우에 사용해주세요.</p>
          </div>
        </>
      )}
      <div
        style={{
          position: 'sticky',
          bottom: 0,
          background: '#fff',
          paddingTop: 8,
          paddingBottom: 8,
          width: '100%',
        }}
      >
        <Button
          variant={'contained'}
          color={'primary'}
          fullWidth
          disabled={!installSubmit?.customerNumber}
          endIcon={<DoubleArrow />}
          onClick={() => {
            remindBeforeSelect(installSubmit)
          }}
        >
          고객 선택 완료
        </Button>
      </div>
    </div>
  )
}

export default SelectInstallableCustomer
